import React, { Component } from 'react';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
class RequestDevice extends Component {

    constructor(props) {
        super(props)
        this.sendEvent = this.sendEvent.bind(this);
    }

    sendEvent() {
        const event = new Event('requestdevice');
        document.dispatchEvent(event);
        this.props.toggleModal();
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} size="md" backdrop="static">
                <Modal.Header>
                    <Modal.Title>{this.props.t("reqdevice")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>{this.props.t("reqdeviceexplanation")}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.sendEvent}>
                        <FontAwesomeIcon icon={duotone("magnifying-glass")} /> {this.props.t("search")}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}



export default withTranslation()(RequestDevice);